
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/highlightResize/resizeHighlight.scss.css.virtualfile';
        module.exports = {"highlightedBox":"_highlightedBox_1fqk2_7","blinkAnimation":"_blinkAnimation_1fqk2_1"};